<template>
  <div class="flex-cc dir-col flex-auto">
    <SMS v-bind="{restOfCount, resendOtp, loading, handleVerify}" />
  </div>
</template>

<script>
  import { mapState, mapActions} from 'vuex';
  import { Button } from 'iview';
  import SMS from '@/components/auth/verify/SMS';
  import { GET_OTP_ACTION,VERIFY_OTP_ACTION } from '@/store/modules/user/constants';
  import { log } from '@/utils/axios';

  export default {
    components: { SMS },
    data() {
      return {
        disabledResend: true
      }
    },
    computed: {
      ...mapState({
        restOfCount: ({ user }) => user.otp.restOfCount,
        loading: ({ user }) => user.loading,
        phoneNo: ({ user }) => user.profile.phoneNo
      })
    },
    methods: {
      ...mapActions([
        GET_OTP_ACTION,
        VERIFY_OTP_ACTION
      ]),
      async handleVerify(authCode) {
        const { $store,phoneNo } = this;
        const verifyStatus = await $store.dispatch(VERIFY_OTP_ACTION,{ authCode, phoneNo, type: 'checkout' });
        if(verifyStatus) {
          const { state } = this.$store; 
          this.$router.push({ 
            name: 'checkoutPayment',
            params: { current: 3 }
          });
        }
      },
      resendOtp() {
        const { $store,phoneNo } = this;
        $store.dispatch(GET_OTP_ACTION,{ phoneNo, type: 'checkout' });
      }
    }
  }
</script>
